import {Inject, Injectable} from '@angular/core';
import {BasedataService} from '@docma-mm-core/shared/basedata.service';
import {HttpClient, HttpParams} from '@angular/common/http';
import {MYDOCMA_SETTINGS_CONFIG, SettingsConfig} from './settings-config';
import {ConfigService} from '@docma-mm-core/config/config.service';
import {SettingTypeEnum} from './setting-type.enum';
import {SettingModuleEnum} from './setting-module.enum';
import {Setting} from './setting';
import {catchError, firstValueFrom, of} from 'rxjs';
import {ValueTypeEnum} from './value-type.enum';
import {map} from 'rxjs/operators';

@Injectable()
export class SettingsApiService  extends BasedataService{

  private readonly settingsUrl = `${this.settingsConfig.apiUrl}/settings`;

  constructor(private http: HttpClient,
              @Inject(MYDOCMA_SETTINGS_CONFIG) private settingsConfig: SettingsConfig,
              configService: ConfigService) {

    super(configService);
  }

  async get(type: SettingTypeEnum, name: string) {
    const endpoint = `${this.settingsUrl}/${SettingModuleEnum.mm}/${type}/${name}`

    return firstValueFrom(this.http.get<Setting>(endpoint, { headers: this.getHeaders() })
      .pipe(catchError(e  => {
        console.warn(`Error getting '${name}' from setting-api. ${this.getError(e)?.message}`);
        return of(null);
      })));
  }

  async create(type: SettingTypeEnum, name: string, value: string) {
    const setting = JSON.stringify(new Setting({value: value, valueType: ValueTypeEnum.string}));
    const endpoint = `${this.settingsUrl}/${SettingModuleEnum.mm}/${type}/${name}`;

    return firstValueFrom(this.http.post<Setting>(endpoint, setting, { headers: this.getHeaders() })
      .pipe(map(m => {
          return m;
        }),
        catchError(e  => {
          console.warn(`Error saving '${name}' to setting-api. ${this.getError(e)?.message}`);
          return of(null);
        })));
  }
  async update(type: SettingTypeEnum, name: string, value: string) {
    const setting = JSON.stringify(new Setting({value: value}));

    return firstValueFrom(this.http.put<Setting>(`${this.settingsUrl}/${SettingModuleEnum.mm}/${type}/${name}`, setting, { headers: this.getHeaders() })
      .pipe(catchError(e  => {
        console.warn(`Error updating '${name}' to setting-api. ${this.getError(e)?.message}`);
        return of(null);
      })));
  }

  delete(type: SettingTypeEnum, name: string) {
    return firstValueFrom(this.http.delete(`${this.settingsUrl}/${SettingModuleEnum.mm}/${type}/${name}`, { headers: this.getHeaders() })
      .pipe(catchError(e  => {
        console.warn(`Error deleting '${name}' to setting-api. ${this.getError(e)?.message}`);
        return of(null);
      })));
  }

  deleteAll(type: SettingTypeEnum, name: string) {
    let httpParams = new HttpParams();
    httpParams.set('settingType', type.toString());

    return firstValueFrom(this.http.delete(`${this.settingsUrl}/${SettingModuleEnum.mm}/${name}`, { headers: this.getHeaders(), params: httpParams })
      .pipe(catchError(e  => {
        console.warn(`Error deleting all '${name}' to setting-api. ${this.getError(e)?.message}`);
        return of(null);
      })));
  }

}
